import Third from 'stores/forms/third';

export default {
    namespaced: true,
    state(){
        return{
            ...Third.state(),
            settings: {
                id: null,
                type: null,
                civility: {label: "", value: null},
                name: null,
                forename : null,
                email: null,
                role: null,
                address: {
                    city: null,
                    postal_code: null,
                }
            },
            listings: {
                types: [],
                civilities: [],
                companiesList: [],
                contactsList: []
            }
        };
    },
    getters: {
        ...Third.getters,
        // COMMUN
        getModel: (state, getters) =>{
            return {
                ...state.settings,
                groupedCustomFields: getters.groupedCustomFields
            };
        },
        getState: (state, getters) => {
            return {settings : state.settings, customfields : [...getters.customFields]};
        },
        getName: (state) => {
            return state.settings.name;
        },
        getType: (state) => {
            return state.settings.type;
        },

        //COMPANY
        getTypes: (state) => {
            return state.listings.types;
        },
        getId: (state) => {
            return state.settings.id;
        },
        getSuggestionCompaniesList: (state) =>{
            return state.listings.companiesList;
        },

        //CONTACT
        getContactsList: (state) => {
            return state.listings.contactsList;
        },
        getForename: (state) => {
            return state.settings.forename;
        },
        getEmail: (state) => {
            return state.settings.email;
        },

        //INDIVIDUAL
        getCivility: (state) => {
            return state.settings.civility;
        },
        getCivilities: (state) => {
            return state.listings.civilities;
        },
    },
    mutations: {
        ...Third.mutations,

        // COMMUN
        setState: (state, payload) => {
            state.settings = {
                id: payload.id || null,
                type: payload.type,
                civility: payload.civility || {label: "", value: null},
                name: payload.name,
                forename : payload.forename || null,
                email: payload.email || null,
                role: payload.role || null,
                address: {
                    city: payload?.address?.city || null,
                    postal_code: payload?.address?.postal_code || null,
                }
            }
        },
        setName: (state, payload) => {
            state.settings.name = payload;
        },
        setType: (state, payload) => {
            state.settings.type = payload;
        },

        //COMPANY
        setTypes: (state, payload) => {
            state.listings.types = payload
        },
        setSuggestionCompaniesList: (state, payload) => {
            state.listings.companiesList = payload;
        },

        //CONTACT
        setContactsList: (state, payload) =>{
            state.listings.contactsList = payload
        },
        setForename: (state, payload) => {
            state.settings.forename = payload;
        },
        setEmail: (state, payload) => {
            state.settings.email = payload;
        },
        //INDIVIDUAL
        setCivility: (state, payload) => {
            state.settings.civility = payload;
        },
        setCivilities: (state, payload) => {
            state.listings.civilities = payload;
        },
    },
    actions :{
        ...Third.actions,

        buildDefaultState: ({commit}, defaultValue) => {
            commit("setState", defaultValue);
        },
        fetchThirdMetadata({ getters, commit }, third){
            return new Promise((resolve, reject) => {
                ApiClient.get(`/${third}/metadata`, {}).then((res) => {
                    commit("setTypes", res.data.types.filter(type => type !== "supplier"));
                    if(third === "individuals"){
                        commit("setCivilities", res.data.civilities);
                        if(_.isNil(getters.getCivility) || !getters.getCivility?.value){
                            commit("setCivility", res.data.civilities.find(civilities => civilities.value === "mr"));
                        }
                    }
                    resolve(res);
                }, err => {
                    reject(err);
                })
            })
        },
    },
}